<template>
  <div :class="getAppClasses">
    <StatusNotificationBar :notification="notification"/>
    <!-- Guest content -->
    <div v-if="!authenticated">
      <router-view @authenticated="refreshSession"/>
    </div>
    <!--Authenticated content -->
    <div v-else-if="!signingOut">
      <top-bar :admin="isAdmin" :admin-mode="adminMode" :user="user"/>
      <SideMenu>
        <div id="page">
          <router-view @refresh-session="refreshSession"/>
        </div>
      </SideMenu>
      <intercom :admin="isAdmin"/>
      <ConfirmDialog/>
    </div>
  </div>
</template>

<script lang="ts">
import axios from 'axios';
import StatuspageIoApi from '@/data/external/StatuspageIoApi.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import SideMenu from '@/presentation/components/mainmenu/SideMenu.vue';
import TopBar from '@/presentation/components/topbar/TopBar.vue';
import LocalePrimeVue from '@/presentation/mixins/LocalePrimeVue.js';
import { useUiStore } from '@/stores/UiStore.ts';
import Intercom from './components/intercom/Intercom.vue';
import StatusNotificationBar from './components/topbar/StatusNotificationBar.vue';
import SignIn from './pages/authentication/SignIn.vue';

export default {
  name: 'App',
  components: {
    SideMenu,
    SignIn,
    StatusNotificationBar,
    Intercom,
    TopBar,
  },
  mixins: [LocalePrimeVue],
  data() {
    return {
      notification: {},
      authenticated: useSessionStore().isValid(),
      isAdmin: useSessionStore().isAdmin,
      adminMode: useSessionStore().adminMode,
      user: useSessionStore().user,
    };
  },
  created() {
    this.trackUser();
    this.getNotification();
    this.updatePrimeVueLocale(useUiStore().locale);
    this.$i18n.locale = useUiStore().locale;

    this.$watch(
      () => useUiStore().locale,
      (locale) => {
        try {
          this.updatePrimeVueLocale(locale);
        } catch (Throwable) {
          // ignoring
        }
      },
    );
  },
  methods: {
    refreshSession() {
      this.authenticated = useSessionStore().isValid();
      this.isAdmin = useSessionStore().isAdmin;
      this.adminMode = useSessionStore().adminMode;
      this.user = useSessionStore().user;

      this.trackUser();
    },
    async getNotification() {
      try {
        const response = await axios.get(
          'https://sundata.statuspage.io/api/v2/summary.json',
        );
        const spApi = new StatuspageIoApi(response.data);
        this.notification = spApi.getNotification();
      } catch (e) {
        this.notification = StatuspageIoApi.notification(
          'Status info currently not available',
          'info',
          true,
        );
      }
    },
    trackUser() {
      if (
        !this.authenticated ||
        import.meta.env.VITE_NODE_ENV === 'development'
      ) {
        return;
      }

      this.$gtag.config({
        user_id: this.user.id,
      });
    },
  },
  computed: {
    signingOut(): boolean {
      return useSessionStore().signingOut;
    },
    getAppClasses: function () {
      const classes = [];
      if (this.notification && this.notification.show) {
        classes.push('hasNotification');
      }
      return classes.join(' ');
    },
  },
};
</script>
